<template>
    <Axa v-if="icon === 'Logo Axa'" />
    <Hiscox v-else-if="icon === 'Logo Hiscox'" />
    <InformationFile v-else-if="icon === 'File'" />
    <InformationFileCheck v-else-if="icon === 'File check'" />
    <InformationLegalCheck v-else-if="icon === 'Legal check'" />
    <InformationSecurity v-else-if="icon === 'Security'" />
    <ObjectKey v-else-if="icon === 'Key'" />
    <ObjectLock v-else-if="icon === 'Lock'" />
    <PaymentFee v-else-if="icon === 'Fee'" />
    <PeopleUsersCheck v-else-if="icon === 'Users check'" />
</template>

<script setup lang="ts">
    import type {PropType} from 'vue';
    import Axa from '~/assets/svg/reinsurance/axa_logo.svg';
    import Hiscox from '~/assets/svg/reinsurance/hiscox_logo.svg';
    import InformationFileCheck from '~/assets/svg/reinsurance/information_file-check_color_light.svg';
    import InformationFile from '~/assets/svg/reinsurance/information_file_color_light.svg';
    import InformationLegalCheck from '~/assets/svg/reinsurance/information_legal-check_color_light.svg';
    import InformationSecurity from '~/assets/svg/reinsurance/information_security_color_light.svg';
    import ObjectKey from '~/assets/svg/reinsurance/object_key_color_light.svg';
    import ObjectLock from '~/assets/svg/reinsurance/object_lock_color_light.svg';
    import PaymentFee from '~/assets/svg/reinsurance/payment_fee_color_light.svg';
    import PeopleUsersCheck from '~/assets/svg/reinsurance/people_users-check_color_light.svg';

    defineProps({
        icon: {
            validator(value: string) {
                return ['Fee', 'File', 'File check', 'Key', 'Legal check', 'Lock', 'Security', 'Users check', 'Logo Axa', 'Logo Hiscox'].includes(
                    value,
                );
            },
            default() {
                return 'File';
            },
            type: String as PropType<
                'Fee' | 'File' | 'File check' | 'Key' | 'Legal check' | 'Lock' | 'Security' | 'Users check' | 'Logo Axa' | 'Logo Hiscox'
            >,
        },
    });
</script>
